import React from "react";

interface VectorFireworksProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
    style?: React.CSSProperties;
    color?: string;
}

const VectorFireworks = ({ className, style, color = "#FFD700", ...props }: VectorFireworksProps) => {
    return (
        <svg
            className={className}
            style={{ ...style, filter: `drop-shadow(0 0 5px ${color})` }}
            {...props}
            viewBox="0 0 100 100"
            fill="none"
            stroke={color}
            strokeWidth="2.5"
            strokeLinecap="round"
        >
            <path d="M50 35 L50 10" />
            <path d="M50 65 L50 90" />
            <path d="M65 50 L90 50" />
            <path d="M35 50 L10 50" />
            <path d="M60.6 39.4 L78.3 21.7" />
            <path d="M39.4 60.6 L21.7 78.3" />
            <path d="M60.6 60.6 L78.3 78.3" />
            <path d="M39.4 39.4 L21.7 21.7" />
        </svg>
    );
};

export default VectorFireworks;

